<template>
  <div class="wx-mobile">
    <h3>{{L('微信掃碼')}}/{{L('长按识别二维码')}}</h3>
    <img src="@/assets/images/qcode/wx.jpg" style="width: 100%;height: auto;">
  </div>
</template>

<script>
export default {
  name: 'wx-mobile',
  data() {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
.wx-mobile{
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
  h3{
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
    margin-top: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/wx-mobile/index.vue